(function ($) {
	$.stickySubMenu = function (element, options) {
		// **************************************************************
		// Public Properties
		// **************************************************************

		var $c = $(element), // Context 

			StickySubMenu = (function ($c, o) {
				var defaults = {
					target: '.main-header',
					activeClass: 'active',
					scrolledClass: 'scrolled'
				};

				var _o = {},

					wp = null, // Waypoint for Menu

					$d = null, // Duplicate
					$t = null // Target for Duplicate
				;

				var _InitObjects = function () {
					_o = $.extend({}, defaults, o);
					
					$t = $(_o.target);

					_DuplicateMenu();
				},

					_DuplicateMenu = function() {
						$d = $c.clone();
						$t.append($d);
					},

				_BindEvents = function () {
					// Set waypoint
					$('.root-section').each(function() {
						wp = new Waypoint({
							element:  $(this).get(0),
							handler: _OnWayPoint,
							offset: $t.height()
						});
					});
				},

					_OnWayPoint = function(direction) {
						var $$ = $($(this)[0].element);

						if (direction == 'up') {
							$$ = $$.prev();
						}

						var h = $$.prop('id');

						$('a', $d).removeClass(_o.activeClass);
						if (h != '') {
							$('a[href="#'+h+'"]').addClass(_o.activeClass);
						}
					},

				init = (function() {
					_InitObjects();
					_BindEvents();
				})();
			}) ($c, options);
	};

	$.fn.stickySubMenu = function (options) {
		return this.each(function () {
			if (undefined === $(this).data('stickySubMenu')) {
				var plugin = new $.stickySubMenu(this, options);
				$(this).data('stickySubMenu', plugin);
			}
		});
	};
})(jQuery);
